import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class GtmService {
  constructor() {}

  sendEvent(event) {
    if ((<any>window).dataLayer) {
      (<any>window).dataLayer.push({
        event: "GAevent",
        GAevent: "Test - " + event,
        eventAction: "click",
        GA_category: "Widget"
      });
    } else {
      console.warn("No existe dataLayer");
    }
  }

  sendVirtualPage(event) {
    let current = window.location.href;
    if ((<any>window).dataLayer) {
      (<any>window).dataLayer.push({
        event: "Pageview",
        pagePath: current,
        pageTitle: event.urlAfterRedirects //some arbitrary name for the page/state
      });
    } else {
      console.warn("No existe dataLayer");
    }
  }
}
